<template>
  <div>
    <HeaderComponent />
    <SidebarComponent />
    <div id="main-content" :class="[footerTypeIs, contentClass]">
      <slot></slot>
    </div>
    <AuthFooterComponent :footerType="footerTypeIs" />
  </div>
</template>
<script>
export default {
  name: "DefaultLayout",
  props: {
    props: String,
  },
  watch: {
    isIdle(isIdleNow) {
      if (isIdleNow) {
        this.handleIdleLogout();
      }
    },
  },
  methods: {
    async handleIdleLogout() {
      // Fully clear the local auth state on idle timeout — not just the JWT.
      // Leaving authMethod/MSAL account behind (the old behaviour) created an
      // inconsistent state that the login page then tried to clean up
      // asynchronously, racing the next sign-in and silently wiping a fresh
      // session. A complete local clear (no Microsoft redirect) lets the user
      // sign back in cleanly, including via Microsoft SSO.
      // Remember where the user was so we can send them back there after they
      // sign in again. clearAllAuth() wipes prevURL, so capture it first and
      // restore it afterwards. Fall back to the current route if unset.
      const returnUrl =
        localStorage.getItem("prevURL") ||
        (this.$route.path !== "/page-login" ? this.$route.fullPath : null);

      try {
        const [{ default: authService }, { default: entraIdAuth }] =
          await Promise.all([
            import("@/services/auth/authService"),
            import("@/services/auth/entraIdAuth"),
          ]);

        // Clear the MSAL cache/active account, then all backend auth data
        // (jwtToken, authMethod, currentUser, msalAccount, userProfile, ...).
        entraIdAuth.clearAuthState();
        authService.clearAllAuth();

        // Reset cached permissions/roles and the unified auth Vuex state.
        this.$store.dispatch("authpermission/clearAuthData");
        this.$store.commit("clearAuth");
      } catch (error) {
        console.error("Error during idle logout cleanup:", error);
        // Fallback: at minimum drop the backend token so the route guard
        // treats the user as logged out.
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("authMethod");
      } finally {
        // Restore the intended return URL so the login flow sends the user
        // back to the page they were on (login handlers read prevURL).
        if (returnUrl) {
          localStorage.setItem("prevURL", returnUrl);
        }

        this.$cookies.remove("transaction-list-filter");
        this.$cookies.remove("remitter-list-filter");
        this.$cookies.remove("receiver-list-filter");
        this.$cookies.remove("receiver-show-deleted-blacklisted");
        this.$toast.success("Idle timeout...!!", { position: "top-right" });
        if (this.$route.path !== "/page-login") {
          this.$router.push("/page-login");
        }
      }
    },
  },
  components: {
    HeaderComponent: () =>
      import("@/components/admin/layouts/header/HeaderComponent.vue"),
    SidebarComponent: () =>
      import("@/components/admin/layouts/sidebar/SidebarComponent.vue"),
    AuthFooterComponent: () =>
      import("@/components/admin/layouts/footer/AuthFooterComponent.vue"),
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    footerTypeIs() {
      var currentfooterType = "";
      if (this.$route.name == "cdashboard") {
        currentfooterType = "client";
      } else {
        currentfooterType = "admin";
      }
      return currentfooterType;
    },

    contentClass() {
      var currentcontentClass = "";
      if (
        this.$route.name == "blog_list" ||
        this.$route.name == "blog_details"
      ) {
        currentcontentClass = "blog-page";
      } else if (
        this.$route.name == "typography" ||
        this.$route.name == "fdocuments" ||
        this.$route.name == "fimages" ||
        this.$route.name == "fmedia"
      ) {
        currentcontentClass = "file_manager";
      } else if (
        this.$route.name == "pgallery" ||
        this.$route.name == "ptimeline"
      ) {
        currentcontentClass = "profilepage_1";
      }
      return currentcontentClass;
    },
  },
};
</script>
